export enum TenantSettingsControlTypeKeysEnum {
    Features = 'Features',
    Integration = 'Integration',
    Installed = 'Installed',
}
export enum TenantSettingsUniqueIdKeysEnum {
    Members = 'Members',
    TimeTrackerSettings = 'TimeTrackerSettings',
    DynamicFormDomainSettings = 'DynamicFormDomainSettings',
    ImportExportDataSettings = 'ImportExportDataSettings',
    Sprints = 'Sprints',
    Notes = 'Notes',
    Reminder = 'Reminder',
    TenantWebhookSettings = 'TenantWebhookSettings',
    TenantSlackIntegrations = 9,
}
export enum TenantSettingsKeysEnum {
    TenantEnableImportExport = 'TenantEnableImportExport',
    TenantEnableTimeTracker = 'TenantEnableTimeTracker',
    TenantEnableReminders = 'TenantEnableReminders',
    TenantEnableSprints = 'TenantEnableSprints',
    TenantDynamicFormDomainsKey = 'TenantDynamicFormDomainsKey',
    TenantEnableDynamicForm = 'TenantEnableDynamicForm',
    TenantEnableReminder = 'TenantEnableReminders',
    TenantEnableNotes = 'TenantEnableNotes',
    TenantEnableAutoSaveNotes = 'TenantEnableAutoSaveNotes',
    TenantAutoSaveIntervalNotes = 'TenantAutoSaveIntervalNotes',
    TenantEnableWebhook = 'TenantEnableWebhook',
}
